import { render, staticRenderFns } from "./OliverSalesTeam.vue?vue&type=template&id=511ac1dd"
import script from "./OliverSalesTeam.vue?vue&type=script&lang=js"
export * from "./OliverSalesTeam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports